import React from "react";
import { StyledIcon } from "./Icon.styled";
import CustomIcons, { IconMapMember } from "../../assets/iconComponents";

export type Icons = {
  [key: string]: () => React.JSX.Element;
};

export interface IconProps {
  size?: "inherit" | "xs" | "small" | "medium" | "big" | "xl";
  name: IconMapMember;
  //TODO: use specific colors from palette
  color?: string;
  isFill?: boolean;
  className?: string;
}

export function Icon({
  size = "medium",
  name,
  color = "inherit",
  isFill = false,
  className,
}: IconProps) {
  const isCustom = (name as IconMapMember)?.includes("WSC_ICON");

  const getIcon = () => {
    const CustomIcon = CustomIcons[name as keyof typeof CustomIcons];
    return CustomIcon ? <CustomIcon /> : name;
  };

  const getWrapperProps = () => {
    if (!isCustom) {
      return {
        className: `material-symbols-outlined ${className}`,
        fill: Number(isFill),
      };
    }

    return {
      className,
    };
  };

  return (
    <StyledIcon
      size={size}
      color={color}
      aria-hidden="true"
      {...getWrapperProps()}
    >
      {getIcon()}
    </StyledIcon>
  );
}
